export const SHOPIFY_ORDER_QUERY = `
  query {
    orders(first: 5, query: "name:{orderNo} AND email:{email}") {
      edges {
        node {
          id
          name
          createdAt
          displayFulfillmentStatus
          totalPriceSet {
            shopMoney {
              amount
              currencyCode
            }
          }
          email
          shippingAddress {
            name
            address1
            address2
            city
            province
            provinceCode
            zip
            country
            countryCode
            phone
          }
          lineItems(first: 20) {
            edges {
              node {
                name
                quantity
                sku
                originalUnitPriceSet {
                  shopMoney {
                    amount
                    currencyCode
                  }
                }
                variant {
                  id
                  title
                  product {
                    id
                    title
                    tags
                  }
                  inventoryItem {
                    harmonizedSystemCode
                    countryCodeOfOrigin
                    measurement {
                      weight {
                        value
                        unit
                      }
                    }
                  }
                  media(first: 1) {
                    edges {
                      node {
                        ... on MediaImage {
                          image {
                            url
                            altText
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
